import React, { useState } from "react";
import { SearchIcon } from "lucide-react";
import { Tab } from "../../../views/convoauto-pages/bot-studio/types";
import { ACTIONS, ACTIONS_BY_TRIGGER, RCS_ACTIONS, TRIGGERS } from "../../../views/convoauto-pages/bot-studio/constant";
import ChatNeutral from '../../../assets/images/chat-neutral.png'

interface SidebarPanelProps {
  activeTab: Tab;
  setActiveTab: (t: Tab) => void;
  // Which action set to show — RCS_ACTIONS while the RCS trigger is on
  // canvas, the normal ACTIONS list otherwise.
  triggerType?: string;
}

const triggerIcons: Record<string, React.ReactNode> = {
  "Lead from CTWA": (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.3944 20.7349C11.6374 21.7199 10.0624 21.2059 10.0324 19.9639L9.79338 10.1039C9.78745 9.86727 9.84541 9.63338 9.96118 9.42688C10.0769 9.22038 10.2462 9.0489 10.4512 8.93049C10.6562 8.81208 10.8893 8.75111 11.1261 8.754C11.3628 8.7569 11.5943 8.82354 11.7964 8.94693L20.2164 14.0839C21.2764 14.7309 20.9344 16.3519 19.7034 16.5149L15.7164 17.0419C15.3704 17.0879 15.0564 17.2689 14.8444 17.5449L12.3944 20.7349Z" stroke="black" stroke-width="2" stroke-linejoin="round" />
      <path d="M3.79688 8.75005H6.29688M10.0469 5.24805V2.74805M6.81488 5.76505L5.04688 3.99805M13.2789 5.76505L15.0469 3.99805" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  "Message from CTWA": (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.50977 19.8018C8.83126 20.5639 10.3645 21 11.9996 21C16.9702 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.6351 3.43604 15.1684 4.19819 16.4899L4.20114 16.495C4.27448 16.6221 4.31146 16.6863 4.32821 16.7469C4.34401 16.804 4.34842 16.8554 4.34437 16.9146C4.34003 16.9781 4.3186 17.044 4.27468 17.1758L3.50586 19.4823L3.50489 19.4853C3.34268 19.9719 3.26157 20.2152 3.31938 20.3774C3.36979 20.5187 3.48169 20.6303 3.62305 20.6807C3.78482 20.7384 4.02705 20.6577 4.51155 20.4962L4.51758 20.4939L6.82405 19.7251C6.95537 19.6813 7.02214 19.6591 7.08559 19.6548C7.14475 19.6507 7.19578 19.6561 7.25293 19.6719C7.31368 19.6887 7.37783 19.7257 7.50563 19.7994L7.50977 19.8018Z" stroke="#3A3428" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  "On Agent Assign": (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 15C9.713 15 7.65 15.961 6.192 17.5C6.9387 18.2904 7.83906 18.9199 8.83782 19.3498C9.83657 19.7797 10.9127 20.001 12 20C13.0872 20.0008 14.1631 19.7795 15.1616 19.3496C16.1602 18.9197 17.0604 18.2903 17.807 17.5C17.0604 16.7097 16.1602 16.0803 15.1616 15.6504C14.1631 15.2205 13.0872 14.9992 12 15ZM12.47 5.32C12.4325 5.22599 12.3677 5.14538 12.2839 5.08859C12.2001 5.0318 12.1012 5.00145 12 5.00145C11.8988 5.00145 11.7999 5.0318 11.7161 5.08859C11.6323 5.14538 11.5675 5.22599 11.53 5.32L11.276 5.93C10.8515 6.96508 10.0462 7.79793 9.026 8.257L8.308 8.577C8.2162 8.61948 8.13847 8.68734 8.084 8.77257C8.02952 8.85781 8.00057 8.95685 8.00057 9.058C8.00057 9.15915 8.02952 9.25819 8.084 9.34343C8.13847 9.42866 8.2162 9.49652 8.308 9.539L9.068 9.877C10.0628 10.3237 10.8547 11.1263 11.288 12.127L11.533 12.693C11.713 13.107 12.286 13.107 12.467 12.693L12.714 12.128C13.1461 11.1265 13.9378 10.3234 14.933 9.877L15.693 9.539C15.7851 9.49664 15.8631 9.42877 15.9178 9.34343C15.9724 9.25809 16.0015 9.15886 16.0015 9.0575C16.0015 8.95614 15.9724 8.85691 15.9178 8.77157C15.8631 8.68623 15.7851 8.61836 15.693 8.576L14.975 8.256C13.9548 7.79762 13.1492 6.96551 12.724 5.931L12.47 5.32Z" fill="#3A3428" />
    </svg>

  ),
  default: (
    <img src={ChatNeutral} alt="ChatNeutral" />

  ),
};

export const SidebarPanel: React.FC<SidebarPanelProps> = ({
  activeTab,
  setActiveTab,
  triggerType,
}) => {
  const [search, setSearch] = useState("");
  const actionsForTrigger =
    triggerType === "RCS Trigger Node"
      ? RCS_ACTIONS
      : triggerType && ACTIONS_BY_TRIGGER[triggerType]
        ? ACTIONS_BY_TRIGGER[triggerType]
        : ACTIONS;
  const items = activeTab === "Triggers" ? TRIGGERS : actionsForTrigger;
  const filtered = items.filter((i) =>
    i.toLowerCase().includes(search.toLowerCase())
  );

  const handleDragStart = (e: React.DragEvent, type: string) => {
    e.dataTransfer.setData(
      "text/plain",
      JSON.stringify({
        type,
        category: activeTab === "Triggers" ? "trigger" : "action",
      })
    );
  };

  return (
    <div className="w-72 flex-shrink-0 border-r border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 flex flex-col overflow-y-auto">
      <div className="p-4">
        {/* Tab switcher */}
        <div className="flex bg-gray-100 dark:bg-gray-800 rounded-lg p-0.5 mb-4">
          {(["Triggers", "Actions"] as Tab[]).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`flex-1 py-1.5 text-sm font-medium rounded-md transition-all ${activeTab === tab
                ? "bg-white dark:bg-gray-700 shadow-sm text-gray-800 dark:text-gray-200"
                : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Search */}
        <div className="flex items-center gap-2 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2">
          <SearchIcon size={16} className="text-[#7B7B7B] font-semibold dark:text-gray-500" />
          <input
            className="outline-none text-sm text-gray-600 dark:text-gray-300 w-full placeholder-gray-400"
            placeholder="Search Actions and Triggers"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="px-4 pb-4">
        {/* Section label */}
        <p className="text-xs font-semibold text-indigo-600 mb-2">
          {activeTab === "Triggers"
            ? "Start Journey When:"
            : "Define actions for the trigger:"}
        </p>

        <div className="flex flex-col gap-1">
          {filtered.map((item) => (
            <div
              key={item}
              draggable
              onDragStart={(e) => handleDragStart(e, item)}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 hover:bg-indigo-50 hover:border-indigo-200 cursor-grab active:cursor-grabbing transition-colors text-sm text-gray-700 dark:text-gray-300"
            >
              <span className="text-[#7B7B7B] font-semibold dark:text-gray-500">
                {triggerIcons[item] || triggerIcons["default"]}
              </span>
              {item}

              <button title="Triggered when a customer starts a WhatsApp chat through a Click to WhatsApp Ad." className="text-[#7B7B7B] font-semibold dark:text-gray-500">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.00065 1.33398C11.6827 1.33398 14.6673 4.31865 14.6673 8.00065C14.6673 11.6827 11.6827 14.6673 8.00065 14.6673C4.31865 14.6673 1.33398 11.6827 1.33398 8.00065C1.33398 4.31865 4.31865 1.33398 8.00065 1.33398ZM8.00065 2.66732C6.58616 2.66732 5.22961 3.22922 4.22941 4.22941C3.22922 5.22961 2.66732 6.58616 2.66732 8.00065C2.66732 9.41514 3.22922 10.7717 4.22941 11.7719C5.22961 12.7721 6.58616 13.334 8.00065 13.334C9.41514 13.334 10.7717 12.7721 11.7719 11.7719C12.7721 10.7717 13.334 9.41514 13.334 8.00065C13.334 6.58616 12.7721 5.22961 11.7719 4.22941C10.7717 3.22922 9.41514 2.66732 8.00065 2.66732ZM8.00065 10.6673C8.17746 10.6673 8.34703 10.7376 8.47206 10.8626C8.59708 10.9876 8.66732 11.1572 8.66732 11.334C8.66732 11.5108 8.59708 11.6804 8.47206 11.8054C8.34703 11.9304 8.17746 12.0007 8.00065 12.0007C7.82384 12.0007 7.65427 11.9304 7.52925 11.8054C7.40422 11.6804 7.33398 11.5108 7.33398 11.334C7.33398 11.1572 7.40422 10.9876 7.52925 10.8626C7.65427 10.7376 7.82384 10.6673 8.00065 10.6673ZM8.00065 4.33398C8.56217 4.334 9.10616 4.52955 9.53917 4.88705C9.97219 5.24455 10.2672 5.74168 10.3735 6.29304C10.4799 6.8444 10.3909 7.41558 10.1218 7.90846C9.85282 8.40134 9.42056 8.78516 8.89932 8.99398C8.82211 9.02237 8.75252 9.06823 8.69598 9.12798C8.66665 9.16132 8.66198 9.20398 8.66265 9.24798L8.66732 9.33398C8.66713 9.5039 8.60207 9.66734 8.48542 9.7909C8.36877 9.91445 8.20935 9.98881 8.03972 9.99877C7.87009 10.0087 7.70306 9.95354 7.57276 9.84447C7.44246 9.73541 7.35872 9.58072 7.33865 9.41198L7.33398 9.33398V9.16732C7.33398 8.39865 7.95398 7.93732 8.40332 7.75665C8.58619 7.68362 8.74572 7.56216 8.86477 7.40531C8.98383 7.24845 9.0579 7.06213 9.07905 6.86636C9.1002 6.67058 9.06761 6.47274 8.9848 6.29408C8.90199 6.11542 8.77207 5.9627 8.60901 5.8523C8.44595 5.74191 8.25589 5.67802 8.05925 5.6675C7.86262 5.65697 7.66683 5.70021 7.49291 5.79257C7.319 5.88492 7.17352 6.02291 7.07211 6.1917C6.9707 6.3605 6.91719 6.55373 6.91732 6.75065C6.91732 6.92746 6.84708 7.09703 6.72206 7.22206C6.59703 7.34708 6.42746 7.41732 6.25065 7.41732C6.07384 7.41732 5.90427 7.34708 5.77925 7.22206C5.65422 7.09703 5.58398 6.92746 5.58398 6.75065C5.58398 6.10971 5.8386 5.49502 6.29181 5.04181C6.74502 4.5886 7.35971 4.33398 8.00065 4.33398Z" fill="black" />
                </svg>

              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};